/**
 * Exhaustive switch statement.
 * @param value Impossible value.
 * @returns     Error.
 */
export function unreachableCaseError(value: never) {
    return new Error(`${value} is impossible.`);
}
